import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../../utils/helpers/model.helper';
import { StructuredRating } from './structured-rating.model';

export const RATING_SCHEMA = Object.freeze({
  STAR_RATING: 0,
  STRUCTURED_RATINGS: StructuredRating,
});
export const RECORD = generateSchema(RATING_SCHEMA);
export const KEYS: any = generateKeys(RATING_SCHEMA);

export class Rating extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.STRUCTURED_RATINGS,
        value: props.get(KEYS.STRUCTURED_RATINGS)
          ? new StructuredRating(this.structuredRatings)
          : null,
      },
    ]);

    return selfModel as Rating;
  }

  get starRating(): number {
    return this.get(KEYS.STAR_RATING);
  }

  get structuredRatings(): StructuredRating {
    return this.get(KEYS.STRUCTURED_RATINGS);
  }
}
